// Persian/Farsi digit mappings
const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
const englishDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

/**
 * Convert English numbers to Persian numbers
 * @param {number|string} num - Number to convert
 * @returns {string} - Persian number string
 */
export const toPersianNumber = (num) => {
  if (num === null || num === undefined) return '';
  return String(num).replace(/\d/g, (digit) => persianDigits[digit]);
};

/**
 * Convert Persian numbers to English numbers
 * @param {string} num - Persian number string
 * @returns {string} - English number string
 */
export const toEnglishNumber = (num) => {
  if (num === null || num === undefined) return '';
  return String(num).replace(/[۰-۹]/g, (digit) => {
    const index = persianDigits.indexOf(digit);
    return index !== -1 ? englishDigits[index] : digit;
  });
};

/**
 * Format number based on language
 * @param {number|string} num - Number to format
 * @param {string} language - Language code ('en' or 'fa')
 * @returns {string} - Formatted number
 */
export const formatNumber = (num, language = 'fa') => {
  if (num === null || num === undefined) return '';

  if (language === 'fa') {
    return toPersianNumber(num);
  }

  return String(num);
};

/**
 * Format number with thousand separators
 * @param {number} num - Number to format
 * @param {string} language - Language code ('en' or 'fa')
 * @returns {string} - Formatted number with separators
 */
export const formatNumberWithSeparator = (num, language = 'fa') => {
  if (num === null || num === undefined) return '';

  // Convert to number if string
  const number = typeof num === 'string' ? parseFloat(num) : num;

  if (isNaN(number)) return '';

  // Format with thousand separator
  const formatted = number.toLocaleString('en-US');

  // Convert to Persian if needed
  if (language === 'fa') {
    return toPersianNumber(formatted);
  }

  return formatted;
};

export default {
  toPersianNumber,
  toEnglishNumber,
  formatNumber,
  formatNumberWithSeparator
};
